// extracted by mini-css-extract-plugin
module.exports = {"active":"ToggleAngleIcon_active__1hn1P","transition":"ToggleAngleIcon_transition__2Kes7"};